import React from 'react';
import { Map as ImmutableMap } from 'immutable';
import { mkRootUiData } from 'data/rootUi/types';
import { dangerouslyGetTheme } from 'themes/themesSelectors';

import DeleteIcon from '@material-ui/icons/Delete';
import WarningIcon from '@material-ui/icons/Warning';
import MatchIcon from '@material-ui/icons/CompareArrows';
import InfoIcon from '@material-ui/icons/Info';
import HelpIcon from '@material-ui/icons/Help';
import ErrorIcon from '@material-ui/icons/Error';
import OkIcon from '@material-ui/icons/CheckCircle';

import { DIALOG_TYPE as ALERT_DIALOG_TYPE, mkAlertDialogProps } from 'components/Dialogs/AlertDialog/types';
import { DIALOG_TYPE as FORM_DIALOG_TYPE, mkFormDialogProps } from 'components/Dialogs/FormDialog/types';

import { getLogger } from 'utils/logger';


const log = getLogger('components/QDialogs/index.js');

// Config is passed in by using component when composing wrapper
//

const getDialogIcon = (titleIcon) => {

  const theme = dangerouslyGetTheme();
  const iconStyle = {
    marginTop: -3,
    marginRight: 10,
    color: theme.palette.greyScale[2],
  };

  switch (titleIcon) {

    case 'delete':
      return <DeleteIcon style={iconStyle} />;
    case 'warning':
      return <WarningIcon style={iconStyle} />;
    case 'match':
      return <MatchIcon style={iconStyle} />;
    case 'info':
      return <InfoIcon style={iconStyle} />;
    case 'ok':
      return <OkIcon style={iconStyle} />;
    case 'help':
      return <HelpIcon style={iconStyle} />;
    case 'error':
      return <ErrorIcon style={iconStyle} />;

    default:
      return null;
  }
};

export const dialogAlertCustom = ({ title, subtitle, titleIcon, content, onClose, buttons = ['No', 'Yes'], paperStyle, rootStyle, iconsOnDialogAlerts }) => {

  const dialogData = mkRootUiData({
    type: ALERT_DIALOG_TYPE,
    allowNesting: false,
    id: title,
    props: ImmutableMap(mkAlertDialogProps({
      title,
      subtitle,
      content,
      onClose: onClose || (() => {}),
      buttons: onClose ? buttons : ['Ok'],
      paperStyle,
      titleIcon: iconsOnDialogAlerts ? getDialogIcon(titleIcon) : null,
      rootStyle,
    })),
  });
  log.log('Creating Dialog...', dialogData.toJS());
  return dialogData;
};

export const dialogAlert = (
  title,
  content,
  onClose,
  buttons = ['No', 'Yes'],
  titleIcon = 'info',
  iconsOnDialogAlerts
) => {

  const dialogData = mkRootUiData({
    type: ALERT_DIALOG_TYPE,
    allowNesting: false,
    id: title,
    props: ImmutableMap(mkAlertDialogProps({
      title,
      titleIcon: iconsOnDialogAlerts ? getDialogIcon(titleIcon) : null,
      content,
      onClose: onClose || (() => {}),
      buttons: onClose ? buttons : ['Ok'],
    })),
  });
  log.log('Creating Dialog...', dialogData.toJS());
  return dialogData;
};

export const dialogPassword = (title, content, label, onClose, buttons = ['Submit'], titleIcon, iconsOnDialogAlerts) => {
  const dialogData = mkRootUiData({
    type: FORM_DIALOG_TYPE,
    id: title,
    props: ImmutableMap(mkFormDialogProps({
      title,
      content,
      label,
      password: true,
      buttons,
      onClose,
      type: 'formDialog',
      titleIcon: iconsOnDialogAlerts ? getDialogIcon(titleIcon) : null,
    })),
  });
  log.log('Creating Dialog...', dialogData.toJS());
  return dialogData;
};

export const dialogForm = (title, content, label, onClose, buttons = ['No', 'Yes'], titleIcon, iconsOnDialogAlerts) => {
  const dialogData = mkRootUiData({
    type: FORM_DIALOG_TYPE,
    id: title,
    props: ImmutableMap(mkFormDialogProps({
      title,
      content,
      label,
      buttons,
      onClose,
      type: 'formDialog',
      titleIcon: iconsOnDialogAlerts ? getDialogIcon(titleIcon) : null,
    })),
  });
  log.log('Creating Dialog...', dialogData.toJS());
  return dialogData;
};

